import React, { useCallback, useState } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { useSnackbar } from 'notistack'
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import api from 'utils/api'
import * as businessActions from 'modules/Business/actions'
import { saveAutoReloadPreference } from 'utils/businessAutoReload'
import AutoReloadPreference, {
  useAutoReloadPreference,
} from 'modules/Business/components/AutoReloadPreference'

const AddCard = ({ businessId, card, cards, onClose }) => {
  const dispatch = useDispatch()
  const business = useSelector(state => state.business)
  const [selectedCard, setSelectedCard] = useState(card)
  const { enqueueSnackbar } = useSnackbar()
  const autoReloadPreference = useAutoReloadPreference(business)
  const { isValid: autoReloadIsValid, reloadAmount } = autoReloadPreference

  const handleChange = useCallback(
    (e) => {
      setSelectedCard(e.target.value)
    }, []
  )

  const handleSubmit = useCallback(
    async () => {
      if (!selectedCard) {
        return
      }
      try {
        await api.put(`/business/${businessId}/card/${selectedCard}?isDefault=true`)
        try {
          await saveAutoReloadPreference(
            businessId,
            reloadAmount
          )
        } catch (e) {
          enqueueSnackbar(
            'Card selected, but auto reload could not be updated.',
            { variant: 'warning' }
          )
        }
        onClose()
        enqueueSnackbar('Card added to your business account', { variant: 'success' })
        dispatch(businessActions.fetchBusiness(businessId, true))
      } catch (e) {
        enqueueSnackbar('Cannot setup your card', { variant: 'error' })
      }
    }, [businessId, dispatch, enqueueSnackbar, onClose, reloadAmount, selectedCard]
  )

  return (
    <Dialog open fullWidth maxWidth="sm" onClose={onClose}>
      <DialogTitle>Select credit card</DialogTitle>
      <DialogContent>
        <FormControl variant="outlined" fullWidth>
          <InputLabel>Your cards</InputLabel>
          <Select
            value={selectedCard}
            onChange={handleChange}
            label="Your cards"
          >
            {
              cards &&
              cards.map(c => (
                <MenuItem key={c.id} value={c.id}>
                  {c.brand} **** **** **** {c.last4} - expires on {c.expMonth}/{c.expYear}
                </MenuItem>
              ))
            }
          </Select>
        </FormControl>
        <AutoReloadPreference preference={autoReloadPreference} sx={{ mt: 3 }} />
      </DialogContent>
      <DialogActions>
        <Box display="flex" justifyContent="flex-end">
          <Button color="primary" onClick={onClose}>Cancel</Button>
          <Button
            color="primary"
            disabled={!selectedCard || !autoReloadIsValid}
            variant="contained"
            onClick={handleSubmit}
          >
            Save
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default AddCard;
